var _g, _text, _line, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 420 120",
    role: "img",
    "aria-label": "Chandni Chownk Matka",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chandni Chownk Matka") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42 34 h26 a4 4 0 0 1 0 8 h-4 c14 8 22 22 22 37 a31 31 0 0 1 -62 0 c0 -15 8 -29 22 -37 h-4 a4 4 0 0 1 0 -8 z",
    fill: "#B3122B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 55,
    cy: 80,
    rx: 21,
    ry: 19,
    fill: "#F4C542"
  }), /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 88,
    textAnchor: "middle",
    fontFamily: "Inter, 'Segoe UI', sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#131218"
  }, "00"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 104,
    y: 56,
    fontFamily: "Inter, 'Segoe UI', sans-serif",
    fontSize: 30,
    fontWeight: 800,
    fill: "#131218",
    letterSpacing: 0.5
  }, "CHANDNI CHOWNK")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 105,
    y1: 70,
    x2: 404,
    y2: 70,
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 104,
    y: 99,
    fontFamily: "Inter, 'Segoe UI', sans-serif",
    fontSize: 25,
    fontWeight: 600,
    fill: "#B3122B",
    letterSpacing: 10.5
  }, "MATKA")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteLogo);
export default __webpack_public_path__ + "static/media/WebsiteLogo.e62d6edbd3f69467f3dcdf1f283e8f81.svg";
export { ForwardRef as ReactComponent };